import { render, staticRenderFns } from "./form-success.vue?vue&type=template&id=5c6a8cbd"
import script from "./form-success.vue?vue&type=script&lang=js"
export * from "./form-success.vue?vue&type=script&lang=js"
import style0 from "./form-success.vue?vue&type=style&index=0&id=5c6a8cbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports